import React from "react";
import OnboardingLayout from "./OnboardingLayout";
import { HiArrowRight } from "react-icons/hi";
import { HiOutlineSparkles } from "react-icons/hi2";

/** Step in the onboarding flow where users describe their goals. */
interface StepGoalsProps {
  description?: string;
  onDescriptionChange?: (value: string) => void;
  onContinue?: () => void;
  onBack?: () => void;
  hasExistingPersonas?: boolean;
  onExit?: () => void;
}

function StepGoals({
  description,
  onDescriptionChange,
  onContinue,
  onBack,
  hasExistingPersonas,
  onExit,
}: StepGoalsProps) {
  return (
    <OnboardingLayout showProgress progressValue={0.6} hasExistingPersonas={hasExistingPersonas} onExit={onExit}>
      <div className="px-8 pb-10 pt-6">
        <div className="flex items-start gap-4">
          <div className="rounded-3xl bg-[rgba(162,187,191,0.1)] p-2">
            <HiOutlineSparkles className="text-eai-primary-500" size={24} />
          </div>
          <div>
            <p className="text-base font-semibold text-eai-dark">
              What are you hoping to achieve?
            </p>
            <p className="text-sm text-gray-500">
              In a few sentences describe what you're trying to achieve with this product
            </p>
          </div>
        </div>

        <textarea
          className="mt-8 w-full rounded-lg border border-eai-bg-lt2 px-4 py-3 text-sm text-eai-dark focus:border-eai-primary-500 focus:outline-none"
          rows={5}
          value={description}
          placeholder="I'm looking to optimize our wind portfolio's day-ahead bidding strategy and improve forecast accuracy across our 500MW fleet..."
          onChange={(event) => onDescriptionChange?.(event.target.value)}
        />

        <div className="mt-8 flex justify-end gap-3">
          <button
            type="button"
            onClick={onBack}
            className="rounded-lg border border-eai-bg-lt2 px-4 py-2 text-sm text-eai-dark hover:border-eai-primary"
          >
            Back
          </button>
          <button
            type="button"
            onClick={onContinue}
            disabled={!description || description.trim().length === 0}
            className="inline-flex items-center gap-2 rounded-lg bg-eai-primary-accent px-6 py-2 text-sm font-medium text-white transition enabled:hover:opacity-90 disabled:opacity-50"
          >
            Continue
            <HiArrowRight />
          </button>
        </div>
      </div>
    </OnboardingLayout>
  );
}

export default StepGoals;